module.exports = __webpack_public_path__ + "static/media/04-6WHEELS_CRAN.6946c8bd.png";